export const COMPANY_NAME = 'Katalog Marzeń';
export const EMAIL_ADDRESS = 'biuro@katalogmarzen.pl';
export const PHONE_NUMBER = '+48 739 102 990';
export const PHONE_OFFICE_HOURS = 'Pon-pt 8:00-16:00';
export const BANK_TRANSFER_ACCOUNT = 'PL 67 1140 2004 0000 3002 8318 5613';
export const BANK_TRANSFER_ADDRESS_LINE_1 = 'KatalogMarzen.pl';
export const BANK_TRANSFER_ADDRESS_LINE_2 = 'ul. Kijowska 5, 03-738 Warszawa';
export const COMPANY_LOCATION = {
  lat: 52.2511408,
  lng: 21.0424957
};
export const COMPANY_CITY = 'Warszawa';
export const COMPANY_POSTAL_CODE = '03-738';
export const COMPANY_STREET = 'ul. Kijowska 5';
export const COMPANY_SUPPORT_NAME = 'Katalog Marzeń - Biuro Obsługi Klienta';

export const FULL_ORGANISATION_NAME = 'Katalog Marzeń sp. z o.o.';
export const ORGANISATION_NIP = 'NIP: 521 35 37 169';
export const ORGANISATION_REGON = 'REGON: 141935425';
export const ORGANISATION_KRS = 'KRS: 0001246207';

export const ORGANISATION_WORKING_DAYS = 'Poniedziałek - Piątek';
export const ORGANISATION_CUSTOMER_SERVICE_HOURS = 'Infolinia: 8:00 - 18:00';
export const ORGANISATION_OFFICE_HOURS = 'Biuro: 8:00 - 16:00';
